export default __webpack_public_path__ + "static/media/startNode.21377517.PNG";